<template>
  <div v-bem="{rtl: $i18n.locale === 'ar'}">
    <div v-bem:content>
      <span v-bem:close @click="$emit('close-clicked')">&times;</span>
      <p v-bem:title>{{$t('steps.equipment.title')}}</p>
      <Loader v-if="!optionsList.length" />
      <div v-else>
        <perfect-scrollbar :options="{wheelPropagation: false}">
          <div class="text-right">
            <select class="sort" name="sort" v-model="sort">
              <option value="ascendant">Prix par ordre ascendant</option>
              <option value="descendant">Prix par ordre descendant</option>
            </select>
          </div>
          <div v-bem:list class="row">
            <div
              v-bem:list:item
              class="row"
              v-for="(option, index) in optionsListSorted"
              :key="option.id"
            >
              <div class="col-5 col-m-5" v-if="option.photo">
                <img :src="option.photo" :alt="option.nomoption">
              </div>
              <div :class="option.photo ? 'col-7 col-m-7' : 'col-12'">
                <div class="text">
                  <p v-bem:name>{{option.nomoption}}</p>
                  <p v-bem:price>{{priceFormat(option.prix)}} <sub>MAD</sub></p>
                  <div v-bem:btn="{selected: option.selected}" @click="selectOption(option, index)"><span>{{$t('cta.select')}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
      <div class="footer-btn">
        <button class="button button--primary" @click="$emit('close-clicked')"><span class="button__text">{{$t('cta.validate')}}</span></button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

export default {
  name: 'AccessoriesPopin',
  components: {
    PerfectScrollbar,
    Loader: () => import('@/components/Loader.vue')
  },
  data: () => ({
    sort: 'ascendant'
  }),
  methods: {
    selectOption(option, index) {
      this.optionsList[index].selected = !this.optionsList[index].selected
      const item = this.options.findIndex(({id}) => id === option.id)
      if (item === -1) this.$store.dispatch('addOption', option)
      else this.$store.dispatch('removeOption', option.id)
    }
  },
  computed: {
		...mapGetters([
      'version',
      'optionsList',
      'options'
    ]),
    optionsListSorted() {
      return this.optionsList.sort((a, b) => this.sort === 'ascendant' ? a.prix - b.prix : b.prix - a.prix)
    }
  },
  // created() {
  //   this.$store.commit('filterAccessoriesOptions', this.version.id)
  // }
}
</script>


<style lang="scss">
.accessories-popin {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 9999999999;
  background-color: rgba($black, 0.7);
  select {
    appearance: none;
    background-color: $gray;
    border: rem(1) solid darken($gray, 5%);
    padding: rem(12) rem(20) rem(12) rem(10);
    background-image: url(../assets/img/icons/sort.svg);
    background-repeat: no-repeat;
    background-position: 95% 50%;
    background-size: rem(10);
    margin: 0 rem(16) rem(8) 0;
  }
  &__content {
    @extend %transform-center;
    background-color: $white;
    width: 95%;
    max-width: rem(520);
    padding: rem(30) rem(4) rem(16);
  }
  &__close {
    position: absolute;
    top: rem(4);
    right: rem(12);
    @include font-size(22);
    font-weight: bold;
    cursor: pointer;
  }
  &__title {
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
    @include font-size(22);
    margin-bottom: rem(16);
    span {
      display: block;
      color: $dark-gray;
      @include font-size(14);
      font-weight: normal;
      text-transform: initial;
      max-width: rem(360);
      margin: rem(4) auto rem(16);
    }
  }
  .ps {
    height: rem(500) !important;
    &__rail-x,
    &__rail-y {
      display: block !important;
      opacity: 0.6 !important;
      height: rem(500) !important;
    }
    &__rail-x {
      width: 15px !important;
    }
    &__thumb-y {
      min-height: rem(60);
    }
    &__rtl {
      .ps__rail-x,
      .ps__rail-y {
        right: unset !important;
        left: 0 !important;
      }
    }
  }
  &__list {
    &-item {
      margin: rem(16) 0;
      .text {
        padding: 0 rem(16);
      }
    }
  }
  &__name {
    font-family: var(--primary-font-bold);
    margin-bottom: rem(4);
  }
  &__price {
    font-family: var(--primary-font-bold);
    color: rgba(var(--primary-color), 1);
    @include font-size(28);
    margin-bottom: rem(8);
    sub {
      @include font-size(12);
      color: $black;
      vertical-align: initial;
    }
  }
  &__btn {
    position: relative;
    display: inline-block;
    background-color: rgba(var(--primary-color), 1);
    font-family: var(--primary-font-bold);
    padding: rem(6) rem(16) rem(8);
    @include font-size(14);
    cursor: pointer;
    border: rem(1) solid transparent;
    &:hover {
      background-color: var(--primary-color-hover);
    }
    span {
      color: $white;
      &::before {
        content: "+";
        margin-right: rem(2);
      }
    }
    &--selected {
      background-color: $white;
      border-color: rgba(var(--primary-color), 1);
      span {
        color: $main-color;
        &::before {
          content: "\2713";
        }
      }
      &::after {
        content: "\2715";
        position: absolute;
        top: rem(-1);
        right: 0;
        transform: translateX(100%);
        background-color: rgba(var(--primary-color), 1);
        padding: rem(6) rem(10) rem(8);
        font-family: var(--primary-font);
        color: $white;
        border: rem(1) solid rgba(var(--primary-color), 1);
      }
      &:hover {
          background-color: $white;
        &::after {
          background-color: var(--primary-color-hover);
        }
      }
    }
  }
  &--rtl {
    .accessories-popin__name {
      font-family: var(--primary-font-bold) !important;
    }
    .accessories-popin__price {
      direction: ltr;
      text-align: right;
    }
    .accessories-popin__btn {
      &--selected {
        &::after {
          padding: rem(7.5) rem(10);
          left: rem(-66);
          right: initial;
        }
      }
    }
  }
  .footer-btn {
    text-align: center;
    margin-top: rem(16);
  }
}
</style>